import { render, staticRenderFns } from "./AnswerResult.vue?vue&type=template&id=465bb415&scoped=true"
import script from "./AnswerResult.vue?vue&type=script&lang=js"
export * from "./AnswerResult.vue?vue&type=script&lang=js"
import style0 from "./AnswerResult.vue?vue&type=style&index=0&id=465bb415&prod&lang=scss&scoped=true"
import style1 from "./AnswerResult.vue?vue&type=style&index=1&id=465bb415&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465bb415",
  null
  
)

export default component.exports